import React, {Component} from 'react';
import {Row, Col, Collapse, Empty} from 'antd';
import moment from 'moment';

import {Order} from '../../../../../../interfaces';

const {Panel} = Collapse;

interface Properties {
  orderData: Order;
}

class XMLHistory extends Component<Properties> {
  render() {
    const {orderData} = this.props;
    const history = (orderData && orderData.order && orderData.order.history) || [];
    const renderHistory = history.filter((item: any) => !!item.xml);

    return (
      <Row>
        <Col span={24}>
          {renderHistory.length ? (
            <Collapse defaultActiveKey={['1']}>
              {renderHistory.map((item: any, index: number) => (
                <Panel header={moment(Number(item.date) ? new Date(Number(item.date)) : new Date(item.date)).format('YYYY-MM-DD HH:mm')} key={index.toString()}>
                  {item.xml}
                </Panel>
              ))}
            </Collapse>
          ) : (
            <Empty />
          )}
        </Col>
      </Row>
    );
  }
}

export default XMLHistory;



// WEBPACK FOOTER //
// ./src/pages/OrdersHistoryPage/components/ListOrders/components/ListOrders/components/XMLHistory/XMLHistory.tsx